<template>
    <modal title="Schadensmeldung erfolgreich">
        <p>
            Deine Schadensmeldung wurde erfolgreich an Wüstenrot übermittelt
            <span
                v-if="
                    formData.modrive &&
                    formData.modrive === 'Ja' &&
                    formData.modriveVersicherungsart !== 'Nur Haftpflicht'
                "
                >und du wirst umgehend von MO'Drive kontaktiert</span
            >.
        </p>
        <p>
            In der App kannst du alle übermittelten Schadensmeldungen unter dem
            Menüpunkt Schadensmeldung einsehen.
        </p>
        <p>
            Du solltest in Kürze eine Bestätigungsmail erhalten.
        </p>
        <template v-slot:footer>
            <ion-button class="-round" expand="block" @click="finish"
                >Fertig</ion-button
            >
        </template>
    </modal>
</template>

<script>
import Modal from "@/components/Modal";

export default {
    components: {
        Modal,
    },
    props: {
        formData: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {};
    },
    methods: {
        finish() {
            this.$ionic.modalController.dismiss();
        },
    },
};
</script>

<style></style>
